import React from 'react';

import { fg } from '@confluence/feature-gating';

import {
	type UseRovoBridgeCommandListenerParams,
	useRovoBridgeCommandListener,
} from './useRovoBridgeCommandListener';

export const RovoBridgeCommandListener = (props: UseRovoBridgeCommandListenerParams) => {
	useRovoBridgeCommandListener(props);
	return null;
};

/**
 * Used to conditionally include useRovoBridgeCommandListener
 */
export const MaybeRovoBridgeCommandListener = (props: UseRovoBridgeCommandListenerParams) => {
	if (!fg('aifc_create_enabled')) {
		return null;
	}

	return <RovoBridgeCommandListener {...props} />;
};
